export const getSafeFilename = (filename: string) => {
  return filename.replace(/[/\\:*?"><|]+/g, '');
};
